import { TextArea as PasteTextArea, Label } from "@twilio-paste/core";

import { Field } from "../../store/definitions";

type TextAreaProps = {
    field: Field;
    onChange?: (newValue: string) => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLElement>) => void;
    value?: string;
};

export const TextArea = ({ field, onChange, onKeyPress, value }: TextAreaProps) => {
    const { name, label, placeholder, required } = field;

    return (
        <>
            <Label htmlFor={name}>{label}</Label>
            <PasteTextArea
                placeholder={placeholder}
                name={name}
                id={name}
                value={value ?? ""}
                onChange={(e) => onChange?.(e.target.value)}
                required={required}
                onKeyPress={(e) => onKeyPress?.(e)}
            />
        </>
    );
};
